/* WALKO — menu mobile et apparitions au défilement (toutes les pages hors fiche produit). */
(function () {
  var b = document.querySelector('[data-wc-burger]'), nav = document.getElementById('wc-mnav');
  if (b && nav) b.addEventListener('click', function () {
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    nav.hidden = open;
  });
  var els = document.querySelectorAll('.nt-reveal:not(.is-in)');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (e) { io.observe(e); });
})();
